module.exports = {
          srcSet: __webpack_public_path__ + "public/d9452b50e96f885fb9e9eb820a475aed-414.png"+" 414w",
          images:[ {path: __webpack_public_path__ + "public/d9452b50e96f885fb9e9eb820a475aed-414.png",width: 414,height: 150}],
          src: __webpack_public_path__ + "public/d9452b50e96f885fb9e9eb820a475aed-414.png",
          toString:function(){return __webpack_public_path__ + "public/d9452b50e96f885fb9e9eb820a475aed-414.png"},
          
          width: 414,
          height: 150
        }